<template>
  <div class="map-modal">
    <Map
      v-if="displayMap || isTrainersListEmpty"
      :markers="markers"
      :city="city"
    />
    <div v-else class="loading-wrapper map-loading-wrapper">
      <div class="loader">
        <div class="loader-inner ball-pulse">
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
    <div class="button-wrapper">
      <button class="button field-button" @click="closeMap">
        <span class="mr-1 d-inline-block">
          <i class="icon-smallmap-close fz-18" />
        </span>
        <span>{{ $t('common.hide_map') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Map from '~/components/Common/Map'

export default {
  name: 'MapModal',
  components: {
    Map
  },
  data() {
    return {
      displayMap: false,
      markers: []
    }
  },
  computed: {
    ...mapGetters({
      clubsList: 'search/getClubsList',
      city: 'location/getUrlKey',
      isTrainersListEmpty: 'search/getTrainersListFilling'
    })
  },
  watch: {
    markers() {
      this.displayMap = this.markers ? !!this.markers.length : false
    },
    clubsList() {
      this.fillMarkersList()
    }
  },
  mounted() {
    this.fillMarkersList()
  },
  methods: {
    closeMap() {
      this.$emit('clicked')
    },
    fillMarkersList() {
      this.markers = this.clubsList
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/variables';
.map-modal {
  position: relative;
  max-width: 1028px;
  padding: 0 40px;
  background-color: white;
  .close {
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .button-wrapper {
    display: flex;
    justify-content: center;
    padding: 20px 20px 10px 20px;
  }

  .field-button {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    max-width: 200px;
  }
}

.map-header {
  padding: 20px 20px 15px 20px;
  text-align: center;
  font-size: 18px;
}

.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-height: 735px;
  height: 75vh;
}

.ball-pulse > div {
  background-color: $primary;
}
</style>
